import {
  CSSObject,
  DefaultTheme,
  FlattenInterpolation,
  Interpolation,
  InterpolationFunction,
  ThemedStyledProps,
  css,
} from 'styled-components';

type MediaQueryCss = <P extends object>(
  first: CSSObject | InterpolationFunction<ThemedStyledProps<P, DefaultTheme>> | TemplateStringsArray,
  ...interpolations: Interpolation<ThemedStyledProps<P, DefaultTheme>>[]
) => FlattenInterpolation<ThemedStyledProps<P, DefaultTheme>>;

type BP = 'big' | 'medBig' | 'med' | 'medSm' | 'sm';
type MediaQueries = Record<BP, MediaQueryCss>;

export const VERTICAL_MEDIA_QUERIES: MediaQueries = {
  big: (first, ...args) => css`
    @media (max-height: 900px) {
      ${css(first, ...args)};
    }
  `,
  medBig: (first, ...args) => css`
    @media (max-height: 850px) {
      ${css(first, ...args)};
    }
  `,
  med: (first, ...args) => css`
    @media (max-height: 750px) {
      ${css(first, ...args)};
    }
  `,
  medSm: (first, ...args) => css`
    @media (max-height: 650px) {
      ${css(first, ...args)};
    }
  `,
  sm: (first, ...args) => css`
    @media (max-height: 600px) {
      ${css(first, ...args)};
    }
  `,
};
